import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cnames from 'classnames';
import styles from './ProtectedImage.css';
import ProtectionDiv from '../ProtectionDiv';

class ProtectedImage extends Component {
  constructor(props) {
    super(props);

    this.onLoad = this.onLoad.bind(this);
    this.loadImage = this.loadImage.bind(this);
    this.state = { loading: true };
  }

  componentDidMount() {
    this.loadImage();
  }

  componentWillUnmount() {
    if (this.image) {
      this.image.onload = null;
    }
  }

  componentDidUpdate(prevProps) {
    const { src } = this.props;
    if (prevProps.src !== src) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ loading: true }, () => {
        this.loadImage();
      });
    }
  }

  onLoad() {
    this.setState({ loading: false });
  }

  loadImage() {
    const { src } = this.props;
    if (typeof window !== 'undefined') {
      const image = new window.Image();
      image.onload = this.onLoad;
      image.src = src;
      this.image = image;
    } else {
      this.image = null;
    }
  }

  render() {
    const { width, height, protectionDiv } = this.props;
    const { loading } = this.state;
    const ratio = height / width;
    const ratioPercent = Math.floor(ratio * 100);
    const { src } = this.props;
    const { title, roundBorder } = this.props;
    const imageStyles = roundBorder
      ? cnames(styles.image, styles.roundBorder)
      : styles.image;
    const placeholderStyles = loading
      ? styles.placeholder
      : cnames(styles.placeholder, styles.hidden);

    return (
      <div
        style={{
          position: 'relative',
          overflow: 'hidden',
          paddingBottom: `${ratioPercent}%`
        }}
      >
        <div
          className={placeholderStyles}
          alt="Loading amazing piece of art..."
        />
        {loading ? null : <img className={imageStyles} src={src} alt={title} />}
        {protectionDiv ? <ProtectionDiv /> : null}
      </div>
    );
  }
}

ProtectedImage.propTypes = {
  src: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  roundBorder: PropTypes.bool,
  protectionDiv: PropTypes.bool
};

ProtectedImage.defaultProps = {
  roundBorder: false,
  protectionDiv: false
};

ProtectedImage.displayName = 'ProtectedImage';

export default ProtectedImage;
